
import ClinicService from "../../Services/ClinicService";

export const FETCH_CLINICS_REQUEST = "FETCH_CLINICS_REQUEST";
export const FETCH_CLINICS_SUCCESS = "FETCH_CLINICS_SUCCESS";
export const FETCH_CLINICS_FAILURE = "FETCH_CLINICS_FAILURE";

export const FETCH_CLINICS_COUNT_REQUEST = "FETCH_CLINICS_COUNT_REQUEST";
export const FETCH_CLINICS_COUNT_SUCCESS = "FETCH_CLINICS_COUNT_SUCCESS";
export const FETCH_CLINICS_COUNT_FAILURE = "FETCH_CLINICS_COUNT_FAILURE";


export const fetchClinics = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_CLINICS_REQUEST });
    try {
        const response = await ClinicService.getClinicListWithType(payload);
        dispatch({ type: FETCH_CLINICS_SUCCESS, payload: response.data });
    }
    catch (error) {
        dispatch({ type: FETCH_CLINICS_FAILURE, payload: error.message });
    }
}

export const fetchClinicsCount = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_CLINICS_COUNT_REQUEST });
    try {
        const response = await ClinicService.getClinicListCount(payload);
        dispatch({ type: FETCH_CLINICS_COUNT_SUCCESS, payload: response.data.TOTAL_COUNT_STATUS });
    }
    catch (error) {
        dispatch({ type: FETCH_CLINICS_COUNT_FAILURE, payload: error.message });
    }
}